import { Vue } from 'vue-property-decorator';
import CapitalizeFilter from './shared/module/filters/capitalize';
import CapitalizeAllFilter from './shared/module/filters/capitalize-all';
import FormatCurrencyFilter from './shared/module/filters/format-currency';
import GetDateFormatted from './shared/module/filters/get-date-formatted';
import IFilter from './shared/module/filters/ifilter';
import FormatChannelFilter from './shared/module/filters/format-channel';
import FormatPercentageFilter from './shared/module/filters/format-percentage';
import FormatDateRangeFilter from './shared/module/filters/format-date-range';


export default class Filters {
    public static install() {
        const filters: any[] = [
            new CapitalizeFilter(),
            new CapitalizeAllFilter(),
            new FormatCurrencyFilter(),
            new GetDateFormatted(),
            new FormatChannelFilter(),
            new FormatPercentageFilter(),
            new FormatDateRangeFilter()
        ];

        filters.forEach((filterService: IFilter) => Vue.filter(filterService.filterName, (...params) => filterService.filterAction(...params)));
    }
}
